import React, { useState, useEffect, useRef }from 'react'
import { QuickSortNumbersContainer } from '../numbers/QuickSortNumbersContainer';

import styled from "styled-components";
import { VariablePresentation } from './VariablePresentation';

const HighlightChanged = styled.span`
  background: red;
`;

interface NumberProps {
  readonly Number: number;
};

// https://usehooks.com/usePrevious/
// function usePrevious(value : any) {
//   // The ref object is a generic container whose current property is mutable ...
//   // ... and can hold any value, similar to an instance property on a class
//   const ref = useRef();
  
//   console.log('use prev running, value: ' + value)

//   // Store current value in ref
//   useEffect(() => {
//     console.log('\tuse effect inside use prev running, value: ' + value)
//     ref.current = value;
//   }, [value]); // Only re-run if value changes
  
//   // Return previous value (happens before update in useEffect above)
//   return ref.current;
// }

interface IQuickSortPresentationProps {
  Numbers: Array<number> | undefined,
  StepName: string | undefined,
  HI: number | undefined,
  LO: number | undefined,
  ICount: number | undefined,
  JCount: number | undefined,
  Pivot: number | undefined,
  PartitionNumber: number | undefined,
  SortedIndices: Array<number> | undefined,
  StepForward: () => void,
  StepBackward: () => void,
}

function QuickSortPresentation (props: IQuickSortPresentationProps) {

  const prevHIRef = useRef<number | undefined>();
  const prevLORef = useRef<number | undefined>();
  const prevICountRef = useRef<number | undefined>();
  const prevJCountRef = useRef<number | undefined>();
  const prevPivotRef = useRef<number | undefined>();
  
  useEffect(() => {
    // console.log('useeffect ran ... ')
    // console.log(`prevHI: ${prevHI}, props.HI: ${props.HI}`)
    prevLORef.current = props.LO;
    prevHIRef.current = props.HI;
    prevICountRef.current = props.ICount;
    prevJCountRef.current = props.JCount;
    prevPivotRef.current = props.Pivot;
  })

  const prevHI = prevHIRef.current;
  const prevLO = prevLORef.current;
  const prevICount = prevICountRef.current;
  const prevJCount = prevJCountRef.current;
  const prevPivot = prevPivotRef.current;

  return (
    <div>
      {props.Numbers !== undefined &&
        <QuickSortNumbersContainer
          HI={props.HI}
          LO={props.LO}
          ICount={props.ICount}
          JCount={props.JCount}
          PartitionNumber={props.PartitionNumber}
          Pivot={props.Pivot}
          Numbers={props.Numbers}
          SortedIndices={props.SortedIndices}
        />
      }
      <p>
        HI: <VariablePresentation Hilite={prevHI !== props.HI} Variable={props.HI} />        
      </p>
      <p>
        LO: <VariablePresentation Hilite={prevLO !== props.LO} Variable={props.LO} />   
      </p>      
      <p>
        Pivot: <VariablePresentation Hilite={prevPivot !== props.Pivot} Variable={props.Pivot} />   
      </p>      
      <p>
        ICount: <VariablePresentation Hilite={prevICount !== props.ICount} Variable={props.ICount} />   
      </p>
      <p>
        JCount: <VariablePresentation Hilite={prevJCount !== props.JCount} Variable={props.JCount} />
      </p>

      <p>PartitionIndex: {props.PartitionNumber}</p>
      <button
        onClick={() => props.StepBackward()}
      >
        Backward
      </button>
      <button
        onClick={() => props.StepForward()}
      >Forward</button>
      <p>Step name: {props.StepName}</p>
    </div>
  )
}

export { QuickSortPresentation };